import { BREAKPOINTS, GREY_200, SPACING_0_5, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import Image from 'next/image';
import styled from 'styled-components';
import CardBase from '../CardBase';
import type { FormattedImage } from './index.type';

const Card = styled(CardBase)`
    background-color: #fff;
    display: flex;
    flex-direction: column;

    .card-image{
      object-fit: cover;
      object-position: top;
      width: 100%;
      max-height: 16rem;
    }

    .image-placeholder {
      height: 15rem;
      background-color: ${GREY_200};
    }

    .card-body {
      display: flex;
      flex-direction: column;
      gap: ${SPACING_0_5};
      padding: ${SPACING_3};
    }

    .label {
      font-size: 1.125rem;
      font-weight: 500;
      line-height: 120%;
      letter-spacing: -0.03375rem;

      @media (min-width: ${BREAKPOINTS.MD}px) {
        font-size: 1.375rem;
      }
    }

    .sub-text {
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5rem;
    }
`;

type CardContactProps = {
  image: FormattedImage;
  label: string | null | undefined;
  subtext1?: string | null;
  subtext2?: string | null;
};

const CardContact = ({ image, label, subtext1, subtext2 }: CardContactProps) => (
  <Card as="li">
    {image.src ? (
      <Image className="card-image" {...image} />
    ) : (
      <div className="image-placeholder" aria-hidden />
    )}
    <div className="card-body">
      <div className="label">{label}</div>
      {subtext1 && (
        <div>
          <div className="sub-text">{subtext1}</div>
          {subtext2 && <div className="sub-text">{subtext2}</div>}
        </div>
      )}
    </div>
  </Card>
);

export default CardContact;
